import * as React from 'react';

function Exclamation(props) {
	return (
		<svg
			aria-label={`alert icon`}
			xmlns={'http://www.w3.org/2000/svg'}
			width={'33'}
			height={'33'}
			viewBox={'0 0 33 33'}
			fill={'none'}
			{...props}
		>
			<title>alert icon</title>
			<circle
				cx={'16.5'}
				cy={'16.5'}
				r={'16'}
				stroke={'#1F1F1F'}
			/>
			<circle
				cx={'16.5'}
				cy={'22.5'}
				r={'1.5'}
				fill={'black'}
			/>
			<path
				d={'M15.0011 10.3452C14.9684 9.61076 15.649 9 16.5 9C17.351 9 18.0316 9.61076 17.9989 10.3452L17.6562 18.0392C17.6323 18.5757 17.1217 19 16.5 19C15.8783 19 15.3677 18.5757 15.3438 18.0392L15.0011 10.3452Z'}
				fill={'black'}
			/>
		</svg>
	);
}

export default Exclamation;
